import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../shared/AppSettings";
import { Form161Employee, Form161EmployeeFundInstitution, Form161Filter, Form161Header, Form161SaveContainer } from "../model/form161Formaly.model";
import { Observable } from "rxjs";

@Injectable()
export class Form161FormalyService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) {}

  getEmployeAndFundInstitutionsData(filter: Form161Filter) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/Form161Formaly/GetEmployeAndFundInstitutionsData`,
      filter,
      { headers }
    );
  }

  createInitialForm(customerData: Form161Header, form161Status: number): Observable<Form161Header> {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post<Form161Header>(
      `${this.rootUrl}/api/Form161Formaly/createInitialForm?form161Status=${form161Status}`,
      customerData,
      { headers }
    );
  }

  GetFullForm(formId: number, employeeId: number): Observable<Form161Header>  {
    return this.httpClient.get<Form161Header>(`${this.rootUrl}/api/Form161Formaly/GetFullForm?formId=${formId}&employeeId=${employeeId}`);
  }

  GetCityesList(query: string): Observable<string[]>  {
    return this.httpClient.get<string[]>(`${this.rootUrl}/api/Form161Formaly/GetCityesList?query=${query}`);
  }

  

  getEmployeeData(customerIdentityNumber : string, employeeIdentityNumber : string) {
    return this.httpClient.get(`${this.rootUrl}/api/Form161Formaly/GetEmployeeData?customerIdentityNumber=${customerIdentityNumber}&employeeIdentityNumber=${employeeIdentityNumber}`)
  }

  saveEmployeeForm(form161SaveContainer: Form161SaveContainer): Observable<Form161Employee> {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post<Form161Employee>(
      `${this.rootUrl}/api/Form161Formaly/saveEmployeeForm`,
      form161SaveContainer,
      { headers }
    );
  }

  saveEmployeeFundsAndSendToFormaly(form161Employee: Form161Employee): Observable<Form161Employee> {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post<Form161Employee>(
      `${this.rootUrl}/api/Form161Formaly/saveEmployeeFundsAndSendToFormaly`,
      form161Employee,
      { headers }
    );
  }

  getEmployeesWithForm161 = (customerIdentity: string) => {
    return this.httpClient.get(`${this.rootUrl}/api/Form161Formaly/GetEmployeesWithForm161Only?customerIdentity=${customerIdentity}`, )
  }

  downloadForm161(recordId: number) {
    // const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.get(`${this.rootUrl}/api/Form161Formaly/DownloadForm161?recordId=${recordId}`,{ responseType: 'blob' });
  }

  downloadXML(recordId: number) {
    // const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.get(`${this.rootUrl}/api/Form161Formaly/DownloadXML?recordId=${recordId}`,{ responseType: 'blob' });
  }

  getFundinstitution() {
    return this.httpClient.get(`${this.rootUrl}/api/Form161Formaly/GetFundInstitutionList`);
  }

  getIsForm161Allowed(): Observable<boolean>  {
    return this.httpClient.get<boolean>(`${this.rootUrl}/api/Form161Formaly/GetIsForm161Allowed`);
  }
  
  getIsForm161AllowedForCustomer(customerId): Observable<boolean>  {
    return this.httpClient.get<boolean>(`${this.rootUrl}/api/Form161Formaly/GetIsForm161AllowedForCustomer?customerId=${customerId}`);
  }

  resetStatus(recordId: number): Observable<void>  {
    return this.httpClient.get<void>(`${this.rootUrl}/api/Form161Formaly/ResetStatus?recordId=${recordId}`);
  }

  addFundInstitutionToExistingForm(fundInstitution: Form161EmployeeFundInstitution, formId: number, recordId: number): Observable<number> {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post<number>(
      `${this.rootUrl}/api/Form161Formaly/addFundInstitutionToExistingForm?formId=${formId}&recordId=${recordId}`,
      fundInstitution,
      { headers }
    );
  }

  deleteFundInstitutionToExistingForm(formId: number, recordId: number, recordFundInstitutionId: number): Observable<void> {
    return this.httpClient.get<void>(`${this.rootUrl}/api/Form161Formaly/deleteFundInstitutionToExistingForm?formId=${formId}&recordId=${recordId}&recordFundInstitutionId=${recordFundInstitutionId}`);
  }

  copyForm(formId: number): Observable<Form161Header> {
    return this.httpClient.get<Form161Header>(`${this.rootUrl}/api/Form161Formaly/copyForm?formId=${formId}`);
  }

  deactivateEmployee(formId: number, recordId: number): Observable<void> {
    return this.httpClient.get<void>(`${this.rootUrl}/api/Form161Formaly/deactivateEmployee?formId=${formId}&recordId=${recordId}`);
  }


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/form161Formaly.service.ts